import { Box } from "@mui/material"
import type { Row } from "@tanstack/react-table"
import type { FC } from "react"

import { AdjustmentHistoryLotsTable } from "./AdjustmentHistoryLotsTable"

import type { AdjustmentHistoryItem } from "@/graphql/codegen/graphql"

interface AdjustmentHistoryRowDetailsProps {
  row: Row<AdjustmentHistoryItem>
  isPrinting: boolean
  onPalletLabelPrint: (item: AdjustmentHistoryItem, palletReferenceNumber: number) => void
}

export const AdjustmentHistoryRowDetails: FC<AdjustmentHistoryRowDetailsProps> = ({
  row,
  isPrinting,
  onPalletLabelPrint,
}) => {
  const item = row.original
  const { lots, comments, adjustmentType } = item

  return (
    <Box className='flex flex-col gap-y-4 p-6'>
      {comments.length > 0 && (
        <div className='flex flex-col gap-y-1'>
          <span className='text-sm font-medium text-gray-900'>Comment</span>
          {comments.map((comment) => (
            <span key={comment.commentId} className='text-sm text-gray-700'>
              {comment.value}
            </span>
          ))}
        </div>
      )}
      {lots.length > 0 && (
        <AdjustmentHistoryLotsTable
          lots={lots}
          adjustmentType={adjustmentType}
          isPrinting={isPrinting}
          onPalletLabelPrint={(palletReferenceNumber) => onPalletLabelPrint(item, palletReferenceNumber)}
        />
      )}
    </Box>
  )
}
